// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__gA4ON","login":"Logo_login__G+IEs","dashboard":"Logo_dashboard__HZdud","img_logo":"Logo_img_logo__lNROg"};